import * as Yup from 'yup'
import { emptySpaceCharsAtStartAndEndRegex } from './constants'
import { emptySpacesMessage } from './messagesConstants'

export const validateField =
  <T,>(fieldName: string, condition: T) =>
  (val: unknown, ctx: Yup.TestContext) => {
    const fieldParts = fieldName.split('.')
    const fieldToCheck = fieldParts.reduce(
      (acc, part) => acc && acc[part],
      ctx.parent
    )
    if (fieldToCheck === condition) {
      return false
    } else if (typeof fieldToCheck === 'string') {
      return validateStringField(fieldToCheck)
    } else {
      return true
    }
  }

const validateStringField = (fieldToCheck: string) => {
  return Yup.string()
    .matches(emptySpaceCharsAtStartAndEndRegex, `${emptySpacesMessage}.`)
    .isValidSync(fieldToCheck)
}
